<template>
  <div class="auth-wrapper auth-v2">
    <b-overlay :show="show" no-wrap />
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <div class="brand-logo">
        <img src="@/assets/images/logo/logoNew.svg" />
        <div class="brand-logo-text">
          Human Resource System
        </div>
      </div>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center ">
        <div class="w-100 d-lg-flex align-items-center justify-content-center ">
          <b-img
            style="width: 100%;height: auto;"
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="font-weight-bold mb-1 fw-7 black-text ">
            Welcome to HR System!
          </b-card-title>
          <b-card-text class="mb-1 secondary-text ">
            Please sign-in to your account and start the adventure
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mcc-formGroup " @submit.prevent>
              <!-- email -->
              <b-form-group label="Phone Number" label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="phone"
                  rules="required"
                >
                  <div class="flex gap-8 flex-alignItem">
                    <el-input
                      placeholder="Mobile"
                      v-model="loginForm.phone"
                      type="number"
                    >
                      <el-select
                        style="width: 90px"
                        v-model="loginForm.phoneQh"
                        slot="prepend"
                        filterable
                        :filter-method="customFilter"
                      >
                        <el-option
                          v-for="country in filteredCountries"
                          :key="country.code"
                          :label="country.nameLabel"
                          :value="country.zone"
                        >
                        </el-option>
                      </el-select>
                    </el-input>
                    <!-- <div style="width:100px">
                      <b-form-select
                        v-model="loginForm.phoneQh"
                        :options="options"
                      ></b-form-select>
                    </div>

                    <b-form-input
                      id="login-phone"
                      v-model="loginForm.phone"
                      :state="errors.length > 0 ? false : null"
                      name="login-email"
                      placeholder=""
                      type="number"
                    /> -->
                  </div>
                  <small v-if="errors[0]" class="text-danger">{{
                    i18n('login.phoneTip')
                  }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">OTP Code</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="otpCode"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="loginForm.otpCode"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      name="login-password"
                      placeholder=""
                    />
                    <b-input-group-append is-text>
                      <div v-if="sendTimes <= 0">
                        <a-button
                          class="mcc-btn-border"
                          :loading="sendLoading"
                          @click="sendSms"
                        >
                          Send Code</a-button
                        >
                      </div>
                      <div v-else>
                        <a-button class="mcc-btn-border">
                          {{ sendTimes }} s</a-button
                        >
                      </div>
                    </b-input-group-append>
                  </b-input-group>
                  <small v-if="errors[0]" class="text-danger">{{
                    i18n('login.otpCodeTip')
                  }}</small>
                </validation-provider>
              </b-form-group>
              <div class="flex just-sb mb-1">
                <div class="fw-7 primary-text cursor-pointer" @click="back">
                  Back to previous page
                </div>
              </div>

              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group> -->

              <!-- submit buttons -->
              <b-button
                type="submit"
                block
                class="linear-gradient-1 mcc-btn-padding line-22 fw-5"
                @click="handleLogin"
              >
                Sign in
              </b-button>
              <!-- <b-button
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                Sign in
              </b-button> -->
            </b-form>
          </validation-observer>
          <!-- <div class="mt-1 secondary-text fw-5 line-22">
            Or,Sign in with <span class="primary-text fw-7">MCC Portal</span>
          </div> -->
        </b-col>
      </b-col>
    </b-row>
    <a-modal
      v-if="isInitPasswordFlag"
      :visible="isInitPasswordFlag"
      :title="'Please change the password!'"
      :width="950"
      z-index="999"
      :mask-closable="false"
      :footer="null"
      @cancel="cancel"
    >
      <password />
    </a-modal>
    <a-modal
      v-if="showResetBlock"
      :visible="showResetBlock"
      :title="'Reset password'"
      :width="950"
      z-index="999"
      :mask-closable="false"
      :footer="null"
      @cancel="cancelResetBlock"
    >
      <ResetPassword />
    </a-modal>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BFormSelect,
  BImg,
  BForm,
  BButton,
  BOverlay,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import { resetRouter } from '@/router/index'
import Password from '@/views/common/Password.vue'
import ResetPassword from '@/views/common/resetPassword.vue'
import { loginByAiisToken, sendLoginSms } from '@/api/user'
import { getToken } from '@/util/auth'
import { deepClone } from '@/util/util'
import countryCode from '@/util/mobileCode'
extend('phoneNumberS', (value, phoneNumber) => {
  console.log(phoneNumber)
  return phoneNumber[0] !== ''
})
export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
    Password,
    ResetPassword,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      sendLoading: false,
      options: [
        { value: '+65', text: '+ 65' },
        { value: '+86', text: '+ 86' },
      ],
      countries: [],
      filteredCountries: [],
      sendTimer: '',
      sendTimes: 0,
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/logo/vector-sign-in.png'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      show: false,
      // loginForm: {
      //   tenantId: '000000',
      //   username: '',
      //   password: '',
      //   type: 'account',
      //   // image: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      // },
      loginForm: {
        phone: '',
        otpCode: '',
        phoneQh: '+65',
        tenantId: '000000',
        username: '',
        password: '',
        type: 'account',
      },
      showResetBlock: false,
    }
  },
  mounted() {
    const newCountryCode = countryCode
    this.countries = newCountryCode
    this.filteredCountries = [...this.countries]
    this.$store.commit('getIsInitPassWordStatus', false)
  },
  created() {
    if (getToken()) {
      this.$router.replace({ path: '/homePage' })
      return
    }
    const { token } = this.$route.query
    if (token) {
      this.show = true
      const params = {
        aiis_token: token,
        grant_type: 'aiis_token',
      }
      loginByAiisToken(params)
        .then(async (res) => {
          const { data } = res
          if (data.access_token) {
            this.$store.commit('SET_AIIS_TOKEN', token)
            this.$store.commit('SET_TOKEN', data.access_token)
            this.$store.commit('saveUserInfo', data)
            this.$store.commit('SET_REFRESH_TOKEN', data.refresh_token)
            this.$store.commit('SET_TENANT_ID', data.tenant_id)
            this.$store.commit('SET_USER_INFO', data)

            await this.$store.dispatch('GetUserInfo')
            await this.$store.dispatch('GetDicts')
            await this.$store.dispatch('GetTemplateForm')

            this.$router.push({ path: '/homePage' })
            this.show = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'SUCCESS',
                icon: 'BellIcon',
                text: 'login success ',
                variant: 'success',
              },
            })
          }
        })
        .catch((e) => {
          this.show = false
        })
    }
  },
  beforeDestroy() {
    clearInterval(this.sendTimer)
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/logo/vector-sign-in.png')
        return this.sideImg
      }
      return this.sideImg
    },
    isOverTime() {
      let isOverTime = false
      if (this.userAllInfo.updatePasswordTime) {
        const currentTime = moment(new Date())
        const time = moment(this.updatePasswordTime).add(90, 'days')
        const date = moment.max(currentTime, time).format('YYYY-MM-DD')
        isOverTime = moment.max(currentTime, time) === currentTime
      }
      return isOverTime
    },
    ...mapGetters([
      'tagWel',
      'isInitPasswordFlag',
      'userAllInfo',
      'tempUserInfo',
    ]),
  },
  methods: {
    handleLogin() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          const loginForm = deepClone(this.loginForm)
          loginForm.isPhoneLogin = true
          loginForm.phone = `${this.loginForm.phoneQh} ${this.loginForm.phone}`
          this.show = true
          this.$store
            .dispatch('LoginByUsername', loginForm)
            .then((res) => {
              console.log(res, 'sassssss')
              // if (this.isOverTime) {
              //   this.$store.commit('getIsInitPassWordStatus', true)
              // }
              // this.$router.push({ path: this.tagWel.value })
              resetRouter()
              this.$router.push({ path: '/homePage' })
              this.show = false
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'SUCCESS',
                  icon: 'BellIcon',
                  text: 'login success ',
                  variant: 'success',
                },
              })
            })
            .catch((e) => {
              this.show = false
              // this.refreshCode()
            })
        }
      })
    },
    cancel() {
      this.$store.commit('getIsInitPassWordStatus', false)
    },
    sendSms() {
      console.log(this.loginForm)
      if (!this.loginForm.phone) {
        this.$toast({
          component: ToastificationContent,
          props: {
            icon: 'BellIcon',
            text: 'please enter phone number',
            variant: 'danger',
          },
        })
        return
      }
      this.sendLoading = true
      sendLoginSms({
        phone: `${this.loginForm.phoneQh} ${this.loginForm.phone}`,
      })
        .then((res) => {
          console.log(res)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'SUCCESS',
              icon: 'BellIcon',
              text: 'send success ',
              variant: 'success',
            },
          })
          this.sendLoading = false
          this.sendTimes = 60
          this.sendTimer = setInterval(() => {
            if (this.sendTimes > 0) {
              this.sendTimes--
            } else {
              clearInterval(this.sendTimer)
            }
          }, 1000)
        })
        .catch((err) => {
          this.sendLoading = false
        })
    },
    back() {
      this.$router.back()
    },
    customFilter(query) {
      // en: item.en,
      //   cn: item.cn,
      //   code: item.code,
      //   zone
      console.log(query)
      const searchTerm = query.toLowerCase()

      this.filteredCountries = this.countries.filter((country) => {
        return (
          country.en.toLowerCase().includes(searchTerm) || // 匹配国家名称
          country.cn.toLowerCase().includes(searchTerm) ||
          country.code.toLowerCase().includes(searchTerm) ||
          country.zone.toLowerCase().includes(searchTerm)
          // 匹配区号
        )
      })
    },
    cancelResetBlock() {
      this.showResetBlock = false
    },
    handleResetPassword() {
      this.showResetBlock = true
    },
    refreshCode() {
      // getCaptcha().then(res => {
      //   const data = res.data;
      //   this.loginForm.key = data.key;
      //   this.loginForm.image = data.image;
      // })
    },
    i18n(param) {
      return this.$t(`_default.${param}`)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.custom-select {
  padding: 10px;
}
</style>
